<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">كوبونات الخصم</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">كوبونات الخصم</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('coupons_create')" class="row">
          <div class="col text-end">
            <router-link to="/coupons/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة كوبون
            </router-link>
          </div>
        </div>
        <!-- FILTER -->
        <div class="card shadow card-warning card-outline mt-3">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>
          <div class="collapse" id="filterCard">
            <form @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-4 mb-3">
                    <select v-model="filterCategory" class="form-control" @change="onCategoryChange">
                      <option value="all">الكل</option>
                      <option value="properties">العقارات</option>
                      <option value="maintenance">الصيانة</option>
                      <option value="lawyer">اطلب محاميك</option>
                      <option value="photos">طلبات التصوير</option>
                      <option value="adLicense">طلب اصدار ترخيص اعلاني</option>
                      <option value="propertyDocs">توثيق عقد</option>
                      <option value="userPackages">باقات الصيانة</option>
                    </select>
                  </div>
                  <div v-if="filterCategory === 'properties'" class="col-6 col-sm-4 mb-3">
                    <select v-model="filterPropertyPurpose" class="form-control">
                      <option value="all">الغرض (الكل)</option>
                      <option v-for="(val, key) in purposeChoices" :key="key" :value="key">{{ val }}</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm">
                      <i class="fa-solid fa-filter"></i> بحث وتصفية
                    </button>
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter">
                      <i class="fa-solid fa-filter-circle-xmark"></i> إلغاء
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header">
                <div class="card-header d-flex align-items-center">
                  <div class="card-title mb-0">كوبونات الخصم</div>
                    <span v-if="countRows > 0"
                      class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                      عدد النتائج ( {{ countRows }} )</span>  
                  </div>
                </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الوصف</th>
                            <th>الكود</th>
                            <th>يطبق على</th>
                            <th>الغرض</th>
                            <th>الحالة</th>
                            <th>اخر تحديث</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.title }}</td>
                            <td>{{ row.code }}</td>
                            <td>
                              <span v-if="row.category === 'properties'" class="badge bg-primary">العقارات</span>
                              <span v-else-if="row.category === 'maintenance'" class="badge bg-warning text-dark">الصيانة</span>
                              <span v-else-if="row.category === 'lawyer'" class="badge bg-info text-dark">اطلب محاميك</span>
                              <span v-else-if="row.category === 'photos'" class="badge bg-info text-dark">طلبات التصوير</span>
                              <span v-else-if="row.category === 'adLicense'" class="badge bg-info text-dark">طلب اصدار ترخيص اعلاني</span>
                              <span v-else-if="row.category === 'propertyDocs'" class="badge bg-info text-dark">توثيق عقد</span>
                              <span v-else-if="row.category === 'userPackages'" class="badge bg-info text-dark">باقات الصيانة</span>
                              <span v-else class="badge bg-secondary">الكل</span>
                            </td>
                            <td>
                              <span v-if="row.category === 'properties'">
                                {{ purposeChoices[row.propertyPurpose] ?? 'الكل' }}
                              </span>
                              <span v-else>-</span>
                            </td>
                            <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                            <td>
                              <router-link :to="`/coupons/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('coupons_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('coupons_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'CouponsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      filterCategory: this.$route.query.category || 'all',
      filterPropertyPurpose: 'all',
      purposeChoices: {},
      showDateFilter: false,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      countRows: 0,
    }
  },
  methods: {
    checkAccess,
    onCategoryChange(){
      this.filterPropertyPurpose = 'all';
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.filterCategory = 'all';
      this.filterPropertyPurpose = 'all';
      this.currentPage = 1;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let query = `page=${this.currentPage}&category=${this.filterCategory}`;
      if (this.filterCategory === 'properties' && this.filterPropertyPurpose !== 'all') {
        query += `&propertyPurpose=${this.filterPropertyPurpose}`;
      }
      if (this.searchDateFrom) {
        query += `&dateFrom=${this.searchDateFrom}`;
      }
      if (this.searchDateTo) {
        query += `&dateTo=${this.searchDateTo}`;
      }
      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.filterCategory && this.filterCategory !== 'all' ? { category: this.filterCategory } : {}),
        ...(this.filterPropertyPurpose && this.filterPropertyPurpose !== 'all' ? { propertyPurpose: this.filterPropertyPurpose } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/coupons/list?${query}`).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        if(data.propertyPurposeChoices) this.purposeChoices = data.propertyPurposeChoices;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/coupons/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>